import { render, staticRenderFns } from "./page-integrations.vue?vue&type=template&id=1ce03750&"
import script from "./page-integrations.vue?vue&type=script&lang=js&"
export * from "./page-integrations.vue?vue&type=script&lang=js&"
import style0 from "./page-integrations.vue?vue&type=style&index=0&id=1ce03750&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports